/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { ThemeProvider } from 'modules/common/contexts/theme-context';
import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ENVIRONMENT } from 'config';
import useTheme from 'modules/common/hooks/use-theme';
import createTheme from 'modules/common/theme';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Router from './routes';
import store from './store';
/**
 * @returns Entry point in the react application. And also register the providers
 */
const App = () => {
  const { theme } = useTheme();
  //
  const isPtg = window.location.origin === ENVIRONMENT.APP_URL;
  // change favicon and title based on domain
  useEffect(() => {
    const favicon = document.querySelector("link[rel='icon']");
    if (favicon) {
      favicon.href = isPtg
        ? `${ENVIRONMENT.APP_URL}/${ENVIRONMENT.FAVICON}`
        : `${ENVIRONMENT.AIRO_APP_URL}/${ENVIRONMENT.AIRO_FAVICON}`;
    }
  }, []);
  //
  return (
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MuiThemeProvider theme={createTheme(theme)}>
              <Router />
              <ToastContainer />
            </MuiThemeProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
